import React from "react";
import NavigationBar from "@workspace/jobportal/src/components/NavigationBar/NavigationBar";
import { Field, Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import moment from "moment";
import "./CandidateUserLogin.scss";
import { UseURLDataHook } from "@workspace/common";
import { useSelector } from "react-redux";
import { login1FA, loginUser } from "../../../../login/src/store/actions";

const CandidateUserLogin = (props) => {
  document.title = "Candidate Login | RTS";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { paramObj } = UseURLDataHook.useURLData(["redirectURL"]);
  const login1FAMeta = useSelector((state) => state.Login.login1FAMeta);
  const loginWithout1FAMeta = useSelector((state) => state.Login.loginMeta);

  const handleSubmit = (input) => {
    const values = { ...input, isCandidate: true };
    const redirectURLPath = paramObj?.redirectURL;
    if (process.env.REACT_APP_ENABLE_2FA === "true") {
      const redirectURL = redirectURLPath
        ? `redirectURL=${encodeURIComponent(redirectURLPath)}`
        : null;
      dispatch(login1FA(values, navigate, redirectURL));
    } else {
      const redirectURL = redirectURLPath
        ? `${encodeURIComponent(redirectURLPath)}`
        : null;
      dispatch(loginUser(values, navigate, redirectURL));
    }
  };

  const initialValues = {
    username: "",
    password: "",
  };

  const schema = Yup.object().shape({
    username: Yup.string().email().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  let loginMeta =
    process.env.REACT_APP_ENABLE_2FA === "true"
      ? login1FAMeta
      : loginWithout1FAMeta;

  return (
    <>
      <header className="login-navigation-bar">
        <div>
          <NavigationBar />
        </div>
      </header>
      <div className="login-container">
        <Formik initialValues={initialValues} validationSchema={schema}>
          {({ errors, touched, values }) => (
            <div style={{ width: "350px", paddingTop: "100px" }}>
              <Form
                style={{ width: "350px" }}
                classname="p-3 d-flex flex-colum gap-2 align-items-center justify-content-center"
              >
                <h3 className="fw-light text-center mb-4">
                  Continue To Your Account
                </h3>
                <Row className="mb-3">
                  <Col lg={12}>
                    <div>
                      <div className="input-login">
                        <small>Email</small>
                        <Field
                          name="username"
                          type="email"
                          placeholder="Enter Email"
                          className={`form-control login-form-control ${
                            errors.username ? "is-invalid" : ""
                          }`}
                        />
                      </div>
                      {errors.username && touched.username && (
                        <div className="text-danger small mt-1">
                          {errors.username}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={12}>
                    <div>
                      <div className="input-login">
                        <small>Password</small>
                        <Field
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          className={`form-control login-form-control ${
                            errors.password ? "is-invalid" : ""
                          }`}
                        />
                      </div>
                      {errors.password && touched.password && (
                        <div className="text-danger small mt-1">
                          {errors.password}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Button
                  type="submit"
                  className="login-button"
                  onClick={() => handleSubmit(values)}
                  disabled={loginMeta?.isLoading}
                >
                  <span>Continue</span>
                  {loginMeta?.isLoading ? (
                    <Spinner size="sm">Loading...</Spinner>
                  ) : (
                    <span className="mdi mdi-chevron-right"></span>
                  )}
                </Button>
                <Row>
                  <Col
                    lg={12}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <div className="signup-link">
                      <span>Are you new?</span>
                      <span
                        className="fw-semibold cursor-pointer"
                        onClick={() => navigate("/candidate/register")}
                      >
                        Get Started - It's Free!
                      </span>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          )}
        </Formik>
      </div>
      <footer className="login-footer-bar">
        <p>{moment().year()} &copy; Avensys</p>
      </footer>
    </>
  );
};

export default CandidateUserLogin;
